import axios from "axios"
import { getToken, getUser, removeSession, setSession } from "helpers/auth-helper"
import { getConfig, removeConfig, setConfig } from "helpers/config-helper"
import toast from "react-hot-toast"
import { setParameter, getParameter, setGenericSupplier, setBranchList } from "helpers/general-helper"
import { getCurrentBranch } from "helpers/auth-helper"

export const load = async () => {
    await config()
    await auth()
    await loaderMain()

    // Return null (because react router return error when there's no return in loader)
    return null
}

async function config() {
    await axios.get(`${process.env.REACT_APP_GENERIC_API_URL}/configuration`, {
        params: {
            application_id: 1
        }
    })
        .then((response) => {
            setConfig(response.data.data)
        })
        .catch((error) => {
            removeConfig()
        })
}

async function auth() {
    const user = await getUser()
    const token = await getToken()

    if (user === null && token !== null) {
        await axios.post(`${process.env.REACT_APP_GENERIC_API_URL}/token/verify`, {
            token: token
        }).then((response) => {
            setSession(response.data.data.token, response.data.data.user)
            toast.success(response.data.message)
            console.log(response.data.message)
        }).catch((error) => {
            removeSession()
            toast.error(error.response.data.message)
            console.log(error.response.data.message)
        })
    }
}


async function loaderMain() {
    var is_super = false
    const user = getUser()
    const currentBranch = getCurrentBranch()
    const application_id = getParameter("APPLICATION_ID")

    if (user?.roles?.length === 0) {
        is_super = false
    } else {
        if (!currentBranch?.roles) {
            is_super = true
        } else 
        if (currentBranch) {
            is_super = currentBranch?.roles?.find((role) => role.is_super === 1) ? true : false
        } else {
            is_super = user?.roles.find((role) => role.is_super === 1) ? true : false
        }
    }

    await axios.get(`${process.env.REACT_APP_GENERIC_API_URL}/supplier?paginate=false`, {
        params: {application_id: application_id}
    }).then((response) => {
        setGenericSupplier(response?.data?.data)
    }).catch((error) => {
    })

    var title = '/branch/by'
    if (is_super == true) {
        title = '/branch?paginate=false'
    }

    await axios.get(`${process.env.REACT_APP_GENERIC_API_URL}${title}`, {
        params: {user_id: user?.id}
    }).then((response) => {
        setBranchList(response?.data?.data)
    }).catch((error) => {
    })
}